import { render, staticRenderFns } from "./PagamentoDetalhesPagamento.vue?vue&type=template&id=5121028b&"
import script from "./PagamentoDetalhesPagamento.vue?vue&type=script&lang=js&"
export * from "./PagamentoDetalhesPagamento.vue?vue&type=script&lang=js&"
import style0 from "./PagamentoDetalhesPagamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader})
